export default "__VITE_ASSET__CIC9JDjG__"